import React from "react";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { IconWrapperRounded } from "../../../components/IconWrapperRounded";

interface ContactRowProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode;
  text: string;
}

export const ContactRow = ({ icon, text, ...rest }: ContactRowProps) => {
  return (
    <div
      className="d-flex flex-row align-items-center"
      style={{ gap: "16px" }}
      {...rest}
    >
      {icon && (
        <IconWrapperRounded
          backgroundColor={colors.ctaLight}
          color={colors.ctaMain}
        >
          {icon}
        </IconWrapperRounded>
      )}
      <StyledText color={colors.textPrimary} className="bodyTextSemibold mb-0">
        {text}
      </StyledText>
    </div>
  );
};
